<template>
  <o-card :title="''">
    <div class="card-header px-0 pt-0 pb-3 row mt-4 mb-4">
      <div class="col-12">
        <span class="mr-3">{{ $t('medtastic.events') }}</span>
        <br class="d-block d-sm-none">
        <div class="region-hint mr-0">{{ $t('medtastic.event_in') }}
        <b-form-select v-model="filterLanguage" :options="filterLanguages"
                       class="lang-filter bg-primary"
                       v-on:change="workshops"></b-form-select>
        <b-form-select v-model="filterRegion" :options="filterRegions" class="region-filter bg-primary d-none"
                       v-on:change="workshops"></b-form-select>
        </div>
      </div>
    </div>
    <template v-if="loaded">
      <template v-if="workshopsList.length === 0">
        {{ $t('medtastic.no_events') }}
      </template>
      <template v-else>
        <div v-for="workshop in workshopsList" class="upcoming-events">
          <b class="workshop-title">{{ workshop.title }}</b>

          <div class="row">
            <div class="col-12" :class="{ 'col-md-4': workshop.credits, 'col-md-6': !workshop.credits }">
              <div class="mt-4 d-flex">
                <div class="icon-calendar"><img src="/images/calendar.svg"/></div>
                <div class="calendar-text">
                  {{ workshop.date|formatDay }} {{ workshop.date|formatDate }},
                  <br class="d-block d-sm-none">
                  {{ workshop.time|formatTimeString }}-{{ workshop.end_time|formatTimeString }}
                  <template v-if="workshop.with_apero"><br> {{ $t("medtastic.apero_text")}}  </template>
                </div>
              </div>
            </div>
            <div class="col-12" :class="{ 'col-md-4': workshop.credits, 'col-md-6': !workshop.credits }">
              <div class="mt-4 d-flex">
                <div class="icon-location"><img src="/images/location.svg"/></div>
                <div class="location-text"><span v-html="workshop.location"></span>, {{ workshop.region }}</div>
              </div>
            </div>
            <div class="col-12" v-if="workshop.credits" :class="{ 'col-md-4': workshop.credits, 'col-md-6': !workshop.credits }">
              <div class="mt-4 d-flex">
                <div class="icon-location"><img src="/images/credits.svg"/></div>
                <div class="location-text">{{ workshop.credits }}</div>
              </div>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col text-center text-sm-left">
              <router-link :to="{ name: 'medtastic.event_detail', params: {id: workshop.id} }" class="btn btn-dark">
                {{ $t('medtastic.details') }}
              </router-link>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="btn-loading">&nbsp;<br>&nbsp;<br>&nbsp;</div>
    </template>
  </o-card>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  layout: 'user',
  data () {
    return {
      filterLanguage: 'all',
      filterLanguages: {},
      workshopsList: [],
      loaded: false,
      filterRegion: 'all',
      filterRegions: {}
    }
  },
  created () {
    this.languages()
    this.regions()
  },
  computed: mapGetters({
    locale: 'lang/locale'
  }),
  watch: ({
    locale: function (newVal, oldVal) {
      this.languages()
      this.regions()
    }
  }),
  methods: {
    languages: function () {
      this.filterLanguage = 'all'
      this.filterLanguages = []
      this.filterLanguages = Object.assign({ 'all': this.$i18n.t('medtastic.all_languages') },
        window.config.workshop_locale
      )
    },
    regions: function () {
      this.filterRegion = 'all'
      this.filterRegions = []
      axios.get('/api/medtastic/workshops/region')
        .then((response) => {
          this.filterRegions = Object.assign({ 'all': this.$i18n.t('medtastic.all_region') },
            response.data
          )
        })
        .catch((error) => {
          console.log(error)
        })
    },
    workshops: function () {
      this.loaded = false
      var url = '/api/medtastic/workshops/public?per_page=99999&sortBy=date&filter%5Bhide_past_workshops%5D=1&filter%5Bprivate%5D=0'
      if (this.filterLanguage !== 'all') {
        url = url + '&filter%5Blanguage%5D=' + this.filterLanguage
      }

      if (this.filterRegion !== 'all') {
        url = url + '&filter%5Bregion%5D=' + this.filterRegion
      }
      axios.get(url)
        .then((response) => {
          this.workshopsList = response.data.data
          this.loaded = true
        })
        .catch((error) => {
          console.log(error)
        })
    }
  },
  mounted () {
    this.workshops()
  }
}
</script>
